module.exports = __webpack_public_path__ + "media/images/pause-bf69ddb14cffe7f98c071f373bb3e02f.png";